export default "__VITE_ASSET__CH9D29Z9__"